import { render, staticRenderFns } from "./LInputRadioGroup.vue?vue&type=template&id=b50925c2"
import script from "./LInputRadioGroup.vue?vue&type=script&lang=js"
export * from "./LInputRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports